import React from "react";
import {
  Type,
  Anchor,
  ListItem
} from "discover.medical.react-component-library";
import { StyledList } from "./_.styled";

export const Heading = props => (
  <Type element="h2" marginBottom="md" {...props} />
);

export const Subheading = props => (
  <Type element="h3" marginBottom="md" {...props} />
);

export const Paragraph = props => (
  <Type element="p" marginBottom="md" {...props} />
);

export const Highlight = ({ bold, italic, ...props }) => (
  <Type
    element={italic ? "i" : "span"}
    fontWeight={bold ? "bold" : "normal"}
    {...props}
  />
);

export const Link = ({ inline, ...props }) => {
  const isExternal = props.href?.[0] !== "/";
  const target = isExternal ? "_blank" : "_self";
  const glyph = isExternal ? "launch" : "";

  return (
    <Anchor
      target={target}
      glyph={glyph}
      floatLeft={false}
      marginBottom={inline ? undefined : "md"}
      {...props}
    />
  );
};

export const List = props => <StyledList type="ul" {...props} />;
export { ListItem };
